import Target from '@/assets/graphical-elements/target.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const TargetIcon = ({className}: IconProps) => <Target className={cn('fill-current', className)} />
